import React from 'react'

const Users = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/users',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g strokeWidth='0' fill='none' fillRule='evenodd'>
      <path
        d='M13.974 1.011c1.342 0 2.432 1.133 2.432 2.526 0 1.42-1.122 3.157-2.432 3.157-1.31 0-2.432-1.736-2.432-3.157 0-1.393 1.09-2.526 2.432-2.526M14 7.714c1.93 0 3.429-2.233 3.429-4.154C17.429 1.597 15.89 0 14 0c-1.89 0-3.429 1.597-3.429 3.56 0 1.921 1.498 4.154 3.429 4.154'
        fill={secondaryColor} />
      <path
        d='M14.594 14.571H19V11.49c0-.591-.39-1.128-.97-1.335a12.864 12.864 0 0 0-4.317-.726c-.78 0-1.492.066-2.125.168'
        stroke={primaryColor}
        strokeWidth='1.2'
        strokeLinecap='round' />
      <g>
        <path
          d='M6.974 5.011c1.342 0 2.432 1.133 2.432 2.526 0 1.42-1.122 3.157-2.432 3.157-1.31 0-2.432-1.736-2.432-3.157 0-1.393 1.09-2.526 2.432-2.526M7 11.714c1.93 0 3.429-2.233 3.429-4.154C10.429 5.597 8.89 4 7 4 5.11 4 3.571 5.597 3.571 7.56c0 1.921 1.498 4.154 3.429 4.154'
          fill={secondaryColor} />
        <path
          d='M1 18.571h12V15.49c0-.591-.443-1.128-1.101-1.335-1.049-.331-2.748-.726-4.899-.726s-3.851.395-4.898.725C1.432 14.366 1 14.89 1 15.49v3.081z'
          stroke={primaryColor}
          strokeWidth='1.2' />
      </g>
    </g>
  </svg>
)

export default Users
